module.exports = __webpack_public_path__ + "img/Chain2.3d1060bc.jpg";